import { PropsWithChildren } from 'react'

import { CarouselProps as CarouselTypes } from 'react-multi-carousel'

import * as S from './styles'
import 'react-multi-carousel/lib/styles.css'

type Props = {
  responsive: {
    [key: string]: {
      breakpoint: { max: number; min: number }
      items: number
    }
  }
} & CarouselTypes

export type CarouselProps = PropsWithChildren<Omit<Props, 'children'>>
export const Carousel = ({ children, responsive, ...rest }: CarouselProps) => (
  <S.CarouselContainer
    responsive={responsive}
    infinite
    autoPlay
    autoPlaySpeed={2000}
    slidesToSlide={1}
    arrows={false}
    draggable={false}
    pauseOnHover={false}
    {...rest}
  >
    {children}
  </S.CarouselContainer>
)
